import type { Components } from "@mui/material/styles";

export const MuiInputBase: Components["MuiInputBase"] = {
  styleOverrides: {
    root: {
      minHeight: "calc(3 * var(--rhythm))",
      fontSize: "var(--font-size-m)",
    },
    sizeSmall: {
      minHeight: "calc(2.5 * var(--rhythm))",
    },
  },
};

export const MuiFilledInput: Components["MuiFilledInput"] = {
  styleOverrides: {
    root: {
      backgroundColor: "var(--color-white)",
      borderRadius: "5px",
      "&:hover": {
        backgroundColor: "var(--color-white)",
      },
      "&::before": {
        display: "none",
      },
      "&::after": {
        display: "none",
      },
    },
  },
};

export const MuiOutlinedInput: Components["MuiOutlinedInput"] = {
  styleOverrides: {
    root: {
      backgroundColor: "var(--color-white)",
    },
  },
};
